import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = () => {
  const location = useLocation();

  useEffect(() => {
    const handleScrollToTop = () => {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    };

    // Scroll au chargement initial
    handleScrollToTop();

    // Ajouter un écouteur d'événements pour la navigation
    window.addEventListener('popstate', handleScrollToTop);

    // Nettoyer l'écouteur d'événements
    return () => {
      window.removeEventListener('popstate', handleScrollToTop);
    };
  }, [location]);

  return null;
};

export default ScrollToTop;
